<template>
    <div class="oplysninger">
        <div class="kun-for-personale" @click="handleTap()"></div>
        <h1 style="user-select: none;">{{ $t('oplysninger') }}</h1>
        <!-- <p>{{customerData}}</p> -->
        <!-- <p>{{dawaAddress}}</p> -->
        <!-- <p>Roomtype: {{ this.roomType }}</p> -->
        <!-- <p>roomtype lokal: {{ this.roomType }}</p> -->
        <!-- <p>roomtype store: {{ this.$store.getters.bookingInProgress.roomtype }}</p> -->
        <!-- <p>Koncern: {{ this.$route.params.koncern }}</p> -->
        <!-- <p>detailedEkstras: {{ this.$store.getters.bookingInProgress.detailedEkstras }}</p> -->

        <div class="form">
       
            <div class="formColumn">

                <!-- Navn -->
                <input type="text" v-model="customerData.name" name="name" :placeholder="$t('navn')"          style="width: 250px; height: 15px; margin: 0px 0px 15px 0px;">
                <span v-if="customerDataError.name && submit==1" class="error">{{ $t('mangler')}} {{$t('navn')}}</span>

                <!-- Adresse -->

                <!-- Dansk - brug DAWA autocomplete-->
                    <!-- <vue-dawa v-if="this.customerData.country == 'Danmark'" @select="selectItem($event, 'dawaAddress')" 
                        :val="dawaAddress.oneLineAddress" 
                        :showMax="5" 
                        containerId="adresse" 
                        containerClasses=""
                        fieldClasses="bbstyle"
                        fieldId="dawa-input"
                        fieldName="address" 
                        placeholder="Adresse"
                        :options="{supplerendebynavn: false}"
                    ></vue-dawa> -->

                <!-- Ikke dansk -->
                <!-- <input v-else type="text" v-model="customerData.address" name="address" :placeholder="$t('adresse')" style="width: 250px; height: 15px; margin: 0px 0px 15px 0px;"> -->

                <!-- DAWA er slået fra da nogle gæster ikke kan finde ud af det -->
                <input type="text" v-model="customerData.address" name="address" :placeholder="$t('adresse')" style="width: 250px; height: 15px; margin: 0px 0px 15px 0px;">
                <span v-if="customerDataError.address == 1 && submit==1" class="error">{{ $t('mangler')}} {{$t('adresse')}}</span><br />

                <!-- Postnr & By -->
                <input type="text" v-model="customerData.postnr" name="postalCode" :placeholder="$t('postnr')"    style="width: 45px; height: 15px;">
                <input type="text" v-model="customerData.city" name="city" :placeholder="$t('by')"            style="width: 188px; height: 15px; margin: 0px 0px 15px 2px;">
                <span v-if="customerDataError.postnr && submit==1" class="error">{{ $t('mangler')}} {{$t('postnr')}}</span><br />
                <span v-if="customerDataError.city && submit==1" class="error">{{ $t('mangler')}} {{$t('by')}}</span>

                <!-- Land -->
                <select v-model="customerData.country" @change="updateCC()" name="country" style="width: 265px; margin: 0px 0px 15px 0px; padding: 2px;">
                    <option v-for="country in this.countryData" v-bind:key="country.name" :value="country.name">({{ country.cc }}) - {{ country.name }}</option>
                </select>
                <span v-if="customerDataError.country && submit==1" class="error">{{ $t('mangler')}} {{$t('land')}}</span>

                <!-- Telefon nr og landekode -->
                <input v-else type="text" v-model="customerData.countryCode" disabled name="landekode" autocomplete="false" :placeholder="$t('landekode')" style="width: 45px; height: 15px;">
                <input type="text" v-model="customerData.phone" name="phone" :placeholder="$t('telefon')" style="width: 188px; height: 15px; margin: 0px 0px 15px 2px;">
                <span v-if="customerDataError.countryCode && submit==1" class="error">{{ $t('mangler')}} {{$t('landekode')}}</span>
                <span v-if="customerDataError.phone && submit==1" class="error">{{ $t('mangler')}} {{$t('telefon')}}</span>

                <!-- Registrerings nr (kun parkering) -->
                <span v-if="this.$store.getters.bookingInProgress.roomtype === 'parkering'">
                    <input type="text" v-model="customerData.carreg" name="carreg" :placeholder="$t('carreg')" style="width: 250px; height: 15px; margin: 0px 0px 15px 0px;">
                    <span v-if="customerDataError.carreg && submit==1" class="error">{{ $t('mangler')}} {{$t('carreg')}}</span>
                </span>

                <!-- E-mail -->
                <input type="text" v-model="customerData.email"  name="email" @input="inputUpdate($event)" :placeholder="$t('email')"         style="width: 250px; height: 15px; margin: 0px 0px 15px 0px;">
                <span v-if="customerDataError.email && submit==1" class="error">{{ $t('fejli')}} {{$t('email')}}</span>

                <!-- Gentag E-mail -->
                <!-- compositionUpdate sørger for at gamle android telefoner opdaterer v-model på input feltet under indtastning - ellers bliver "Betalingsoplysninger"-knappen ved med at være gennemsigtig -->
                <!-- <input type="text" :value="customerData.email2" @input="e => customerData.email2 = e.target.value" name="email2" :placeholder="$t('email2')"  style="width: 250px; height: 15px; margin: 0px 0px 15px 0px;"> -->
                <input type="text" v-model="customerData.email2" name="email2" @input="inputUpdate($event)" @compositionupdate="compositionUpdate($event)" :placeholder="$t('email2')"  style="width: 250px; height: 15px; margin: 0px 0px 15px 0px;">
                <span v-if="customerDataError.email2 && submit==1" class="error">{{ $t('mangler')}} {{$t('email2')}}</span>
            </div>

            <div class="formColumn">
                <textarea v-model="customerData.remarks" name="remarks" id="remarks" :placeholder="$t('bemærkninger')" v-bind:style="{ display: remarkDisplayValue }" style="width: 250px; height: 103px; margin: 0px 0px 11px 18px;"></textarea>

                <label class="container" style="width: 250px; height: 115px; margin: 0px 0px 11px 0px;">
                    <input type="checkbox" v-model="customerData.newsletter" name="newletter" id="">{{ $t('tilbud')}}
                    <span class="checkmark"></span>
                </label>
                <label v-if="this.$route.params.koncern != 5406 && this.$route.params.koncern != 1000" class="container" style="width: 250px; height: 103px; margin: 0px 0px 11px 0px;">
                    <input type="checkbox" v-model="customerData.terms" name="terms" id="">{{ $t('accept') }}&nbsp;<span v-html="$t('terms')"></span><br />
                    <!-- <input type="checkbox" v-model="customerData.terms" name="terms" id="">{{ $t('accept') }} {{ $t('terms') }}<br /> -->
                    <span v-if="customerDataError.terms && submit==1" class="error">{{ $t('mangleraccept')}} <span v-html="$t('terms')"></span></span>
                    <span class="checkmark"></span>
                </label>

            </div>
        

        </div>

        <div class="buttonContainer">
<!--             <a href="">
                <div class="continueButton" v-on:click="navigateBack()">
                    <a>&laquo; {{$t('tilbage')}} </a>
                </div>
            </a>
 -->            
            <router-link to="opsummering">
                <div class="continueButton">
                    <a>&laquo; {{ $t('tilbage')}}</a>
                    <!-- <a>{{ $t('betalingsmetode') }} &raquo;</a> -->
                </div>
            </router-link>


<!-- 
    // Dette eksempel virker som vi vil have det til - hvorfor virker det ikke på samme måde i Vue template ?

    notrelevant = "mstrys"; 
    netrelevant2 = 45; 
    terms = false;
    koncern = 1000;

    if((notrelevant && netrelevant2) && terms === true || (koncern === 5406 || koncern === 1000))  {
    console.log('IF3 evaluerer til true')
    } else {
    console.log('IF3 er false')
    }


 -->            

            <a>
                <!-- <p>email2: (name)                             <span v-if="customerData.name">Her: {{ customerData.email2 }}</span></p> -->
                <!-- <p>email2: (name,address,postnr,phone,country,email,email2)                             <span v-if="customerData.name && customerData.address && customerData.postnr && customerData.phone && customerData.country && customerData.email && customerData.email2">Her: {{ customerData.email2 }}</span></p> -->
                <!-- <p>email2: (name,address,postnr,phone,country,email,email2,terms)                             <span v-if="( (customerData.name && customerData.address && customerData.postnr && customerData.phone && customerData.country && customerData.email && customerData.email2) && (customerData.terms === true || (this.$route.params.koncern === 5406 || this.$route.params.koncern === 1000)))">Her: {{ customerData.email2 }}</span></p> -->
            <div v-on:click="storeCustomerData(customerData)" v-if="(customerData.name && customerData.address && customerData.postnr && customerData.phone && customerData.country && customerData.email && customerData.email2) && (customerData.terms === true || (this.$route.params.koncern === 5406 || this.$route.params.koncern === 1000))" class="continueButton">
                
                <a>{{ $t('betalingsmetode') }} &raquo;</a>
            </div>

            <div v-else v-on:click="checkCustomerDataForErrors(customerData)" class="continueButton" style="opacity: 0.2;">
                <!-- <p>{{ customerData.terms }} - {{ this.$route.params.koncern }}</p> -->
                <!-- <p>{{ customerData.name }}, {{ customerData.address }}, {{ customerData.postnr }}, {{ customerData.phone }}, {{ customerData.country }}, {{ customerData.email }}, {{ customerData.email2 }}, {{ customerData.terms }}, {{ customerData.newsletter }}</p> -->
                <a>{{ $t('betalingsmetode') }} &raquo;</a>
            </div>
            </a>
        </div>
    </div>
</template>

<script>
//import router from "vue-router";
import i18n from '@/plugins/i18n';
//import VueDawa from '@ancaio/vue-dawa/sfc';
import '@ancaio/vue-dawa/dist/vue-dawa.css';

export default {
    components: {
        //VueDawa
    },
  name: "App",
  data() {
    return {
        locale: i18n.locale,
        customerData: {'name': '', 'address': '', 'countryCode': '', 'phone': '', 'postnr': '', 'city': '', 'country': '', 'email': '', 'email2': '', 'remarks': '', 'newsletter': false, 'terms': false, 'dawaAddress': {'oneLineAddress': ''}},
        customerDataError: {'name': 1, 'address': 1, 'countryCode': 1, 'phone': 1, 'postnr': 1, 'city': 1, 'country': 1, 'email': 1, 'email2': 1, 'terms': 1},
        validationError: 0,
        submit: 0,
        rooms: [],
        roomType: 'rooms',
        extras: {},
        parkings: {},
        apiLoaded: 0,
        discountCode: '',
        timeout: 0,
        countryData: [{"cc":"+93","name":"Afghanistan"},{"cc":"+358","name":"Aland Islands"},{"cc":"+355","name":"Albania"},{"cc":"+213","name":"Algeria"},{"cc":"+1684","name":"AmericanSamoa"},{"cc":"+376","name":"Andorra"},{"cc":"+244","name":"Angola"},{"cc":"+1264","name":"Anguilla"},{"cc":"+672","name":"Antarctica"},{"cc":"+1268","name":"Antigua and Barbuda"},{"cc":"+54","name":"Argentina"},{"cc":"+374","name":"Armenia"},{"cc":"+297","name":"Aruba"},{"cc":"+61","name":"Australia"},{"cc":"+43","name":"Austria"},{"cc":"+994","name":"Azerbaijan"},{"cc":"+1242","name":"Bahamas"},{"cc":"+973","name":"Bahrain"},{"cc":"+880","name":"Bangladesh"},{"cc":"+1246","name":"Barbados"},{"cc":"+375","name":"Belarus"},{"cc":"+32","name":"Belgium"},{"cc":"+501","name":"Belize"},{"cc":"+229","name":"Benin"},{"cc":"+1441","name":"Bermuda"},{"cc":"+975","name":"Bhutan"},{"cc":"+591","name":"Bolivia, Plurinational State of"},{"cc":"+387","name":"Bosnia and Herzegovina"},{"cc":"+267","name":"Botswana"},{"cc":"+55","name":"Brazil"},{"cc":"+246","name":"British Indian Ocean Territory"},{"cc":"+673","name":"Brunei Darussalam"},{"cc":"+359","name":"Bulgaria"},{"cc":"+226","name":"Burkina Faso"},{"cc":"+257","name":"Burundi"},{"cc":"+855","name":"Cambodia"},{"cc":"+237","name":"Cameroon"},{"cc":"+1","name":"Canada"},{"cc":"+238","name":"Cape Verde"},{"cc":"+ 345","name":"Cayman Islands"},{"cc":"+236","name":"Central African Republic"},{"cc":"+235","name":"Chad"},{"cc":"+56","name":"Chile"},{"cc":"+86","name":"China"},{"cc":"+61","name":"Christmas Island"},{"cc":"+61","name":"Cocos (Keeling) Islands"},{"cc":"+57","name":"Colombia"},{"cc":"+269","name":"Comoros"},{"cc":"+242","name":"Congo"},{"cc":"+243","name":"Congo, The Democratic Republic of the Congo"},{"cc":"+682","name":"Cook Islands"},{"cc":"+506","name":"Costa Rica"},{"cc":"+225","name":"Cote d'Ivoire"},{"cc":"+385","name":"Croatia"},{"cc":"+53","name":"Cuba"},{"cc":"+357","name":"Cyprus"},{"cc":"+420","name":"Czech Republic"},{"cc":"+45","name":"Danmark"},{"cc":"+253","name":"Djibouti"},{"cc":"+1767","name":"Dominica"},{"cc":"+1849","name":"Dominican Republic"},{"cc":"+593","name":"Ecuador"},{"cc":"+20","name":"Egypt"},{"cc":"+503","name":"El Salvador"},{"cc":"+240","name":"Equatorial Guinea"},{"cc":"+291","name":"Eritrea"},{"cc":"+372","name":"Estonia"},{"cc":"+251","name":"Ethiopia"},{"cc":"+500","name":"Falkland Islands (Malvinas)"},{"cc":"+298","name":"Faroe Islands"},{"cc":"+679","name":"Fiji"},{"cc":"+358","name":"Finland"},{"cc":"+33","name":"France"},{"cc":"+594","name":"French Guiana"},{"cc":"+689","name":"French Polynesia"},{"cc":"+241","name":"Gabon"},{"cc":"+220","name":"Gambia"},{"cc":"+995","name":"Georgia"},{"cc":"+49","name":"Germany"},{"cc":"+233","name":"Ghana"},{"cc":"+350","name":"Gibraltar"},{"cc":"+30","name":"Greece"},{"cc":"+299","name":"Greenland"},{"cc":"+1473","name":"Grenada"},{"cc":"+590","name":"Guadeloupe"},{"cc":"+1671","name":"Guam"},{"cc":"+502","name":"Guatemala"},{"cc":"+44","name":"Guernsey"},{"cc":"+224","name":"Guinea"},{"cc":"+245","name":"Guinea-Bissau"},{"cc":"+595","name":"Guyana"},{"cc":"+509","name":"Haiti"},{"cc":"+379","name":"Holy See (Vatican City State)"},{"cc":"+504","name":"Honduras"},{"cc":"+852","name":"Hong Kong"},{"cc":"+36","name":"Hungary"},{"cc":"+354","name":"Iceland"},{"cc":"+91","name":"India"},{"cc":"+62","name":"Indonesia"},{"cc":"+98","name":"Iran, Islamic Republic of Persian Gulf"},{"cc":"+964","name":"Iraq"},{"cc":"+353","name":"Ireland"},{"cc":"+44","name":"Isle of Man"},{"cc":"+972","name":"Israel"},{"cc":"+39","name":"Italy"},{"cc":"+1876","name":"Jamaica"},{"cc":"+81","name":"Japan"},{"cc":"+44","name":"Jersey"},{"cc":"+962","name":"Jordan"},{"cc":"+77","name":"Kazakhstan"},{"cc":"+254","name":"Kenya"},{"cc":"+686","name":"Kiribati"},{"cc":"+850","name":"Korea, Democratic People's Republic of Korea"},{"cc":"+82","name":"Korea, Republic of South Korea"},{"cc":"+965","name":"Kuwait"},{"cc":"+996","name":"Kyrgyzstan"},{"cc":"+856","name":"Laos"},{"cc":"+371","name":"Latvia"},{"cc":"+961","name":"Lebanon"},{"cc":"+266","name":"Lesotho"},{"cc":"+231","name":"Liberia"},{"cc":"+218","name":"Libyan Arab Jamahiriya"},{"cc":"+423","name":"Liechtenstein"},{"cc":"+370","name":"Lithuania"},{"cc":"+352","name":"Luxembourg"},{"cc":"+853","name":"Macao"},{"cc":"+389","name":"Macedonia"},{"cc":"+261","name":"Madagascar"},{"cc":"+265","name":"Malawi"},{"cc":"+60","name":"Malaysia"},{"cc":"+960","name":"Maldives"},{"cc":"+223","name":"Mali"},{"cc":"+356","name":"Malta"},{"cc":"+692","name":"Marshall Islands"},{"cc":"+596","name":"Martinique"},{"cc":"+222","name":"Mauritania"},{"cc":"+230","name":"Mauritius"},{"cc":"+262","name":"Mayotte"},{"cc":"+52","name":"Mexico"},{"cc":"+691","name":"Micronesia, Federated States of Micronesia"},{"cc":"+373","name":"Moldova"},{"cc":"+377","name":"Monaco"},{"cc":"+976","name":"Mongolia"},{"cc":"+382","name":"Montenegro"},{"cc":"+1664","name":"Montserrat"},{"cc":"+212","name":"Morocco"},{"cc":"+258","name":"Mozambique"},{"cc":"+95","name":"Myanmar"},{"cc":"+264","name":"Namibia"},{"cc":"+674","name":"Nauru"},{"cc":"+977","name":"Nepal"},{"cc":"+31","name":"Netherlands"},{"cc":"+599","name":"Netherlands Antilles"},{"cc":"+687","name":"New Caledonia"},{"cc":"+64","name":"New Zealand"},{"cc":"+505","name":"Nicaragua"},{"cc":"+227","name":"Niger"},{"cc":"+234","name":"Nigeria"},{"cc":"+683","name":"Niue"},{"cc":"+672","name":"Norfolk Island"},{"cc":"+1670","name":"Northern Mariana Islands"},{"cc":"+47","name":"Norway"},{"cc":"+968","name":"Oman"},{"cc":"+92","name":"Pakistan"},{"cc":"+680","name":"Palau"},{"cc":"+970","name":"Palestinian Territory, Occupied"},{"cc":"+507","name":"Panama"},{"cc":"+675","name":"Papua New Guinea"},{"cc":"+595","name":"Paraguay"},{"cc":"+51","name":"Peru"},{"cc":"+63","name":"Philippines"},{"cc":"+872","name":"Pitcairn"},{"cc":"+48","name":"Poland"},{"cc":"+351","name":"Portugal"},{"cc":"+1939","name":"Puerto Rico"},{"cc":"+974","name":"Qatar"},{"cc":"+40","name":"Romania"},{"cc":"+7","name":"Russia"},{"cc":"+250","name":"Rwanda"},{"cc":"+262","name":"Reunion"},{"cc":"+590","name":"Saint Barthelemy"},{"cc":"+290","name":"Saint Helena, Ascension and Tristan Da Cunha"},{"cc":"+1869","name":"Saint Kitts and Nevis"},{"cc":"+1758","name":"Saint Lucia"},{"cc":"+590","name":"Saint Martin"},{"cc":"+508","name":"Saint Pierre and Miquelon"},{"cc":"+1784","name":"Saint Vincent and the Grenadines"},{"cc":"+685","name":"Samoa"},{"cc":"+378","name":"San Marino"},{"cc":"+239","name":"Sao Tome and Principe"},{"cc":"+966","name":"Saudi Arabia"},{"cc":"+221","name":"Senegal"},{"cc":"+381","name":"Serbia"},{"cc":"+248","name":"Seychelles"},{"cc":"+232","name":"Sierra Leone"},{"cc":"+65","name":"Singapore"},{"cc":"+421","name":"Slovakia"},{"cc":"+386","name":"Slovenia"},{"cc":"+677","name":"Solomon Islands"},{"cc":"+252","name":"Somalia"},{"cc":"+27","name":"South Africa"},{"cc":"+211","name":"South Sudan"},{"cc":"+500","name":"South Georgia and the South Sandwich Islands"},{"cc":"+34","name":"Spain"},{"cc":"+94","name":"Sri Lanka"},{"cc":"+249","name":"Sudan"},{"cc":"+597","name":"Suriname"},{"cc":"+47","name":"Svalbard and Jan Mayen"},{"cc":"+268","name":"Swaziland"},{"cc":"+46","name":"Sweden"},{"cc":"+41","name":"Switzerland"},{"cc":"+963","name":"Syrian Arab Republic"},{"cc":"+886","name":"Taiwan"},{"cc":"+992","name":"Tajikistan"},{"cc":"+255","name":"Tanzania, United Republic of Tanzania"},{"cc":"+66","name":"Thailand"},{"cc":"+670","name":"Timor-Leste"},{"cc":"+228","name":"Togo"},{"cc":"+690","name":"Tokelau"},{"cc":"+676","name":"Tonga"},{"cc":"+1868","name":"Trinidad and Tobago"},{"cc":"+216","name":"Tunisia"},{"cc":"+90","name":"Turkey"},{"cc":"+993","name":"Turkmenistan"},{"cc":"+1649","name":"Turks and Caicos Islands"},{"cc":"+688","name":"Tuvalu"},{"cc":"+256","name":"Uganda"},{"cc":"+380","name":"Ukraine"},{"cc":"+971","name":"United Arab Emirates"},{"cc":"+44","name":"United Kingdom"},{"cc":"+1","name":"United States"},{"cc":"+598","name":"Uruguay"},{"cc":"+998","name":"Uzbekistan"},{"cc":"+678","name":"Vanuatu"},{"cc":"+58","name":"Venezuela, Bolivarian Republic of Venezuela"},{"cc":"+84","name":"Vietnam"},{"cc":"+1284","name":"Virgin Islands, British"},{"cc":"+1340","name":"Virgin Islands, U.S."},{"cc":"+681","name":"Wallis and Futuna"},{"cc":"+967","name":"Yemen"},{"cc":"+260","name":"Zambia"},{"cc":"+263","name":"Zimbabwe"}],
        dawaAddress: {
          oneLineAddress: ''
        },
        remarkDisplayValue: 'none',
        tapCount: 0
    }
  },
  created() {
      this.buildRequest();
    // Læs $store.getters.customerData, slet alt andet end email2 og gem customerData igen
    // Alternativt sæt en 'updated' property på customerData, og slet kun hvis den er eks. over 10 min. gammel

    this.customerData = this.$store.getters.customerData;

    // Vi er skiftet fra LocalStorage til SessionStorage - derfor nulstiller vi ikke længere customerData
    // den bevares kun for den gældende session/vindue med SessionStorage
    /*
    this.customerData.address = '';
    this.customerData.city = '';
    this.customerData.country = '';
    this.customerData.email = '';
    this.customerData.name = '';
    this.customerData.newsletter = false;
    this.customerData.countryCode = '';
    this.customerData.phone = '';
    this.customerData.postnr = '';
    this.customerData.remarks = '';
    this.customerData.terms = false;
    this.$store.dispatch("addCustomerData", this.customerData);
    */
    
    // v-model kan ikke finde ud af at præ-populere en select, derfor sætter vi 'country' værdien per default efter brugerens sprogvalg
    // der kan stadig vælges andet land i drop-down på siden.
    if(this.locale == 'da') {
        this.customerData.country = 'Danmark'
        this.customerData.countryCode = '+45'
    }
    if(this.locale == 'de') {
        this.customerData.country = 'Germany'
        this.customerData.countryCode = '+49'
    }
    if(this.locale == 'en') {
        this.customerData.country = 'United Kingdom'
        this.customerData.countryCode = '+44'
    }
    console.log(i18n.locale);

    this.validationError = 0;
        
    if(!this.validationError) {
        //console.log('Ingen validation error');
    } else {
        console.log('Validation error');
    }

    // Lyt efter keyboard events så vi kan bruge tastaturgenveje
    window.addEventListener('keydown', this.handleKeyDown);    

  },
  beforeDestroy() {
    // Fjern event listener igen
    window.removeEventListener('keydown', this.handleKeyDown);    
  },
  methods: {
        // handle the select event emitted by vue-dawa
        selectItem (payload, objectName) {
            this.$set(this, objectName, this.translateData(payload))
        }, 
        // here the event payload is of the type "adresse"
        translateData (address) {
            if (!address || !address.data) {
                return
            }
            this.customerData.address = address.data.vejnavn + ' ' + address.data.husnr;
            this.customerData.postnr = address.data.postnr;
            this.customerData.city = address.data.postnrnavn;
            return {
                id: address.data.id,
                street: address.data.vejnavn,
                streetNumber: address.data.husnr,
                floor: address.data.etage,
                door: address.data.dør,
                zipCode: address.data.postnr,
                city: address.data.postnrnavn,
                oneLineAddress: address.oneLineAddress // formatted one-line address, OR address.forslagstekst OR address.tekst
            }
        },
      // Opdatér landekode på tlf. når brugers land ændrer sig
      updateCC() {
          for(var i = 0; i < this.countryData.length; i++) {
              if(this.countryData[i].name == this.customerData.country) {
                  this.customerData.countryCode = this.countryData[i].cc;
                  console.log('updateCC: Opdaterer landekode til '+this.countryData[i].cc+' ');
              }
          }
      },
      // Opdaterer email2 ved composition update på gamle Android telefoner
      compositionUpdate: function(event) {
        this.customerData.email2 = event.data;
        console.log('Opdaterer composition...'+JSON.stringify(event.data));
      },
      // Firefox opdaterer ikke "Betalingsmetode"-knap hvis vi ikke laver et checkCustomerDataForErrors() efter hvert tastetryk
      inputUpdate: function(event) {
        //this.customerData.email2 = this.customerData.email2
        this.checkCustomerDataForErrors(this.customerData)
        console.log('Opdaterer input...'+JSON.stringify(event.data));
      },
      checkCustomerDataForErrors(data) {
          this.submit=1;
          if(!data.name || data.name.length < 2) {
              console.log("Name er ikke udfyldt...");
              this.customerDataError.name = 1;
          } else {
              this.customerDataError.name = 0;
          }

          if (!data.address || data.address.length < 2) {
              console.log("Adresse er ikke udfyldt...");
              this.customerDataError.address = 1;
          } else {
              this.customerDataError.address =  0;
          }
          if (!data.postnr || data.postnr.length < 1) {
              console.log("Postnr er ikke udfyldt...");
              this.customerDataError.postnr = 1;
          } else {
              this.customerDataError.postnr = 0;
          }

          if (!data.countryCode || data.countryCode.length < 2) {
              console.log("Landekode er ikke udfyldt...");
              this.customerDataError.countryCode = 1;
          } else {
              this.customerDataError.countryCode = 0;
          }

          if (!data.phone || data.phone.length < 3) {
              console.log("Telefon er ikke udfyldt...");
              this.customerDataError.phone = 1;
          } else {
              this.customerDataError.phone = 0;
          }

          if(this.$store.getters.bookingInProgress.roomtype === 'parkering') {
              if (!data.carreg || data.carreg.length < 3) {
                  console.log("Registreringsnummer er ikke udfyldt...");
                  this.customerDataError.carreg = 1;
              } else {
                  this.customerDataError.carreg = 0;
              }
          }

          if (!data.city || data.city.length < 2) {
              console.log("Bynavn er ikke udfyldt...");
              this.customerDataError.city = 1;
          } else {
              this.customerDataError.city = 0;
          }

          if (!data.country || data.city.length < 2) {
              console.log("Land er ikke udfyldt...");
              this.customerDataError.country = 1;
          } else {
              this.customerDataError.country = 0;
          }

          if (!data.email || !this.validEmail(data.email)) {
              console.log("Email er ikke gyldig...");
              this.customerDataError.email = 1;
          } else {
              this.customerDataError.email = 0;
          }

          if (!data.email2 || data.email.length < 1) {
              console.log("Gentag Email er ikke udfyldt...");
              this.customerDataError.email2 = 1;
          } else {
              this.customerDataError.email2 = 0;
          }

          // Ved visse koncerner vil vi ikke bede gæsten om at acceptere handelsbetingelser
          if(this.$route.params.koncern == 5406 || this.$route.params.koncern == 1000) {
              data.terms = true;
          }

          if (!data.terms || data.terms == false) {
              console.log("Handelsbetingelser er ikke accepterede...");
              this.customerDataError.terms = 1;
          } else {
              this.customerDataError.terms = 0;
          }
      },
      storeCustomerData(data) {
          this.submit=1; // Så vi kun viser fejl hvis der er forsøgt at trykke "videre"
          this.checkCustomerDataForErrors(data);

          if (!this.customerDataError.name && !this.customerDataError.address && !this.customerDataError.postnr && !this.customerDataError.countryCode && !this.customerDataError.phone && !this.customerDataError.carreg && !this.customerDataError.city && !this.customerDataError.country && !this.customerDataError.email && !this.customerDataError.email2) {
              console.log('Alle data tilstede - gemmer data...');

              // Sæt UserID til det indtastede navn i vores OpenReplay
              this.tracker.setUserID(data.name);

              // Sæt landekode foran telefonnummeret
              //data.phone = data.countryCode + " " + data.phone;

              // Gem kundens indtastning i Vuex
              this.$store.dispatch("addCustomerData", data);

              // Opdatér summary og brug rabatkode fra email2
              this.updateSummary();

              // Send videre til betalingssiden
              this.$router.push({ path: 'betaling'});
          }
      },
        // Bygger det JSON request der skal bruges til 'getSummaryData'
        buildRequest() {
            if(this.$store.getters.bookingInProgress.roomtype === 'parkering') {
                this.roomType = 'parkings';
            } else if(this.$store.getters.bookingInProgress.roomtype === 'moedelokale') {
                this.roomType = 'conference';
            } else if(this.$store.getters.bookingInProgress.roomtype === 'selskabslokale') {
                this.roomType = 'selskab';
            } else {
                this.roomType = 'rooms';
            }

            var rooms = [];
            for(var key = 0; key < this.$store.getters.bookingInProgress.wants.length; key++) {
                if(this.$store.getters.bookingInProgress.wants.hasOwnProperty(key)) {
                    if(this.roomType === 'parkings') {
                        rooms.push({space_no: this.$store.getters.bookingInProgress.wants[key], arrival: this.$store.getters.bookingInProgress.startdate, departure: this.$store.getters.bookingInProgress.enddate});
                    } else {
                        rooms.push({roomnr: this.$store.getters.bookingInProgress.wants[key], arrival: this.$store.getters.bookingInProgress.startdate, departure: this.$store.getters.bookingInProgress.enddate});
                    }
                }
            }
            //console.log(JSON.stringify(rooms));
            this.rooms = rooms;

            var ekstras = [];
            for(var key2 in this.$store.getters.bookingInProgress.ekstras) {
                if(this.$store.getters.bookingInProgress.ekstras.hasOwnProperty(key2)) {
                    ekstras.push({id: key2, qty: this.$store.getters.bookingInProgress.ekstras[key2]});
                }
            }

            //console.log(JSON.stringify(ekstras));
            this.ekstras = ekstras;
        },
        updateSummary() {
            this.$store.dispatch("getSummaryData", {
                'koncern': this.$route.params.koncern,
                'language': this.locale,
                'postnr': this.$store.getters.bookingInProgress.hotel,
                'discount_code': this.$store.getters.customerData.email2,
                [this.roomType]: this.rooms,
                'extras': this.ekstras,
                'detailedEkstras': this.$store.getters.bookingInProgress.detailedEkstras
            }).then(() => {this.apiLoaded = 1});
        },

      // Forsøg at kontrollere om e-mail adressen er gyldig
      validEmail(email) {
        //var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        var re = /\S+@\S+\.\S+/;
        return re.test(email);
      },
      navigateBack() {
          if(this.$store.getters.back) {
              // Der er sat en 'back'-værdi i Vuex, send brugeren tilbage til denne side, og slet 'back' i Vuex, da vi har 'brugt' den.
              this.$router.push({ path: this.$store.getters.back }).then(() => { this.$store.dispatch('back', '') });
          } else {
              this.$router.push({ path: "ekstra" });
          }
      },
        // Håndter tastatur genvej (Ctrl + Shift + X) til at toggle bemærkningsfelt
        handleKeyDown(event) {
            if (event.ctrlKey && event.shiftKey && event.key === 'X') {
                this.toggleRemarks();
        }
      },
      toggleRemarks() {
        if(this.remarkDisplayValue == 'none') {
            this.remarkDisplayValue = 'block';
        } else if(this.remarkDisplayValue == 'block') {
            this.remarkDisplayValue = 'none';
        }
      },

    // Håndter multi-tap fra mobil
    handleTap() {
      this.tapCount++;
      // Vi trigger bemærkningsfeltet hvis der tappes 4 gange indenfor 2 sekunder
      if (this.tapCount >= 4) {
        this.toggleRemarks();
        this.tapCount = 0;  // Reset tæller
      }

      // Reset tæller efter 2 sekunder
      setTimeout(() => {
        this.tapCount = 0;
      }, 2000);
    },      

  }
    
}
</script>

/* Vue-dawa er ikke samme komponent som resten, derfor skal der bruges global CSS for at style */
<style>
#dawa-input {
    background: transparent;
    border: 2px solid white;
    color: white;
    padding: 10px 0px 10px 5px;
    width: 266px;
    height: 15px;
}
</style>

<style scoped>

/* Giver de enkelte input-elementer styling, hvid border, transparent baggrund og padding */
.form input[type="text"], [type="checkbox"], textarea {
    background: transparent;
    border: 2px solid white;
    color: white;
    padding: 5px;
}

.form ::placeholder {
    color: rgba(255, 255, 255, 0.50);
}

.bbstyle {
    background: transparent;
    border: 2px solid white;
    color: white;
    padding: 5px;
    width: 250px; 
    height: 15px; 
    margin: 0px 0px 15px 0px;
}

/* Flex container, angiver hvordan den skal opføre sig ved smallere viewport */
.form {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
    padding: 5px;
    max-width: 1024px;
    margin: 0 auto;
    
}
/* De enkelte kolonner i flexboxen */
.formColumn {
    flex: 0 0 30%;
    padding: 5px;
}

::placeholder {
    color: white;
    opacity: 1;
}

.error {
    color: red;
    font-weight: bold;
}




/* Customize the label (the container) */
.container {
  display: block;
  position: relative;
  padding-left: 50px;
  margin-bottom: 12px;
  cursor: pointer;
  font-size: 22px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  text-align: left;
}

/* Hide the browser's default checkbox */
.container input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

/* Create a custom checkbox */
.checkmark {
  position: absolute;
  top: 0;
  left: 0;
  height: 25px;
  width: 25px;
  margin-left: 18px;
  background-color: transparent;
  border: 2px solid white;
}

/* On mouse-over, add a grey background color */
.container:hover input ~ .checkmark {
  background-color: transparent;
}

/* Create the checkmark/indicator (hidden when not checked) */
.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

/* Show the checkmark when checked */
.container input:checked ~ .checkmark:after {
  display: block;
}

/* Style the checkmark/indicator */
.container .checkmark:after {
  left: 7px;
  top: 2px;
  width: 6px;
  height: 14px;
  border: solid white;
  border-width: 0 3px 3px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}


.buttonContainer {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    margin-bottom: 50px;
}

.continueButton {
  -webkit-border-radius: 0;
  -moz-border-radius: 0;
  border-radius: 0px;
  -webkit-box-shadow: 0px 4px 4px #666666;
  -moz-box-shadow: 0px 4px 4px #666666;
  box-shadow: 0px 10px 20px #666666;
  color: #000000;
  background-color: rgba(255,255,255,0.87);
  width: 280px;
  height: 80px;  
  font-size: 150%;
  letter-spacing: 1px;
  padding-left: 10px;
  padding-right: 10px;
  margin: 20px;
  white-space: nowrap;
  flex: 0 0 100%;
  cursor: pointer;
}

a {
  text-decoration: none;
  color: black;
  text-align: center;
  line-height: 80px;
}

/* Denne placerer det touch-felt der bruges til at aktivere bemærkningsfeltet for personalet */
.kun-for-personale {
  position: absolute;
  top: 10px;
  left: 10px;
  width: 100%;
  height: 50px;
}

/* når viewport er mindre end 960 px */
@media (max-width: 768px) {
    /* "Videre"-knappen centreres */
    .continueButton {
        float: none;
        display: inline-block;
    }

    /* De enkelte kolonner i flexboxen */
    .formColumn {
        flex: 0 0 45%;
    }
}

</style>